import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

// Register module store's and routes
import { registerModules } from "./register-modules"
import opdrachtModule from "./modules/opdracht"

registerModules({ opdracht: opdrachtModule })

// Start onAuthStateChanged to bootstrap app
store.dispatch("startFirebase")

createApp(App)
  .use(store)
  .use(router)
  .mount("#app")
